import { FilterTypes } from '../constants/initialFilters';
import { PromotionType } from '../types/offers';
import { parseTrimline } from './parseTrimline';

const getFinalFiltersList = (
  filterType: string,
  filterValue: string,
  listOfFilters: FilterTypes,
  offersList: PromotionType[],
) => {
  const filterArray = listOfFilters[filterType as keyof FilterTypes];

  // const region = offersList.length ? offersList[0].zipClusterID : '';

  const getLatestFilterState = () => {
    // Handle string case (like vehicleType)
    if (typeof filterArray === 'string') {
      if (filterArray === filterValue) {
        return {
          ...listOfFilters,
          [filterType]: [],
        };
      }
      return { ...listOfFilters, [filterType]: filterArray };
    }
    if (filterArray?.includes(filterValue)) {
      return {
        ...listOfFilters,
        [filterType]: [...(filterArray ?? []).filter((toCheck: string) => toCheck !== filterValue)],
      };
    }
    return { ...listOfFilters, [filterType]: [...(filterArray ?? []), filterValue] };
  };

  const latestFilterState = getLatestFilterState();

  const totalCount = offersList.filter((offer) => {
    return (
      (!latestFilterState.offerType.length ||
        latestFilterState.offerType.includes(offer?.offerType?.toLowerCase())) &&
      (!latestFilterState.bodyType.length ||
        latestFilterState.bodyType.includes(offer?.offerModelDetail?.bodyType?.toLowerCase())) &&
      (!latestFilterState.modelFamily.length ||
        latestFilterState.modelFamily.includes(
          offer?.offerModelDetail?.modelFamily?.replace(/[ -]/g, '').toLowerCase(),
        )) &&
      (!latestFilterState.trimLine.length ||
        latestFilterState.trimLine.includes(parseTrimline(offer?.offerModelDetail?.trimline))) &&
      (!latestFilterState.modelYear.length ||
        latestFilterState.modelYear.includes(
          offer?.offerModelDetail?.modelYear?.toString().toLowerCase(),
        ))
    );
  }).length;
  return { latestFilterState, totalCount };
};

export default getFinalFiltersList;
